/* @ngInject */
const myContactForm = (
  $$contact
) => {
  return {
    restrict: 'E',
    scope: {
      myContact: '=',
      enableValidator: '=?',
    },
    template: require('./myContactForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsData = $$contact.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myContactForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/directives/form/myContactForm.js